import { makeFieldValueDbModule } from '../makeFieldValueDbModule';
import { clear as rejectionReasonsServiceClear } from './rejectionReasonsService';
import { makeClearPublisher } from 'serviceWorker/broadcasts/publishers';
import { fieldValueContracts } from 'shared/domain/fieldValue/fieldValueContracts';
import { EditableFieldValuesEntityName } from 'shared/domain/fieldValue/fields';

export const {
  clear,
  quantity,
  get,
  getOne,
  addBatch,
  updateBatch,
  removeBatch,
} = makeFieldValueDbModule({
  tableName: 'rejectionReasons',
  serviceTableName: 'rejectionReasonsService',
  serviceClearFunction: rejectionReasonsServiceClear,
  broadcastClearFunction: makeClearPublisher(fieldValueContracts[EditableFieldValuesEntityName.rejectionReason]),
});
